import { memo } from 'react';

import {
  BUILDER_ROW_TYPES,
  DECIMAL_LIMIT,
} from '../../../../../../constants/campaignBuilder.js';
import { BuilderTableColumn, BuilderTableRow } from '../../../../types.js';
import FormattedField from '../FormattedField/FormattedField.jsx';

export type Props = {
  value: string | number | null;
  column: BuilderTableColumn;
  row: BuilderTableRow;
  cellColor: string;
};

const CurrencyField = memo(({ value, column, row, cellColor }: Props) => {
  const { currencyValue: currency, type, scale } = row.original;

  const isTileRow = type === BUILDER_ROW_TYPES.TILE;
  const decimalLimit = column.decimals ?? DECIMAL_LIMIT.BUDGET;
  const isEmptyCurrencyValueHidden =
    !Number(value) && !!column.hideCurrencyForEmptyValue && !isTileRow;

  return (
    <FormattedField
      scale={scale}
      currency={currency}
      value={value}
      decimalLimit={decimalLimit}
      isEmptyValueHidden={isEmptyCurrencyValueHidden}
      color={cellColor}
      variant="currency"
    />
  );
});
export default CurrencyField;
